import { type ApiError, isApiError, normalizeError } from '@portals-platform/api-client';
import type { FieldValues, UseFormReturn } from '@portals-platform/ui-forms';

export function useServerError<T extends FieldValues>(form: UseFormReturn<T>) {
  const serverError = form.formState.errors.root?.serverError;

  const handleServerError = (error: unknown): ApiError => {
    const apiError = isApiError(error) ? error : normalizeError(error);
    form.setError('root.serverError', { message: apiError.message });

    return apiError;
  };

  return { serverError, handleServerError };
}
